import { Stack, Tooltip } from "@introist/react-foundation/v2";
import { Asterisk } from "lucide-react";
import { EmployeeFieldSelector } from "../../../../employees/fields/EmployeeFieldSelector";
import { EmailAddressCard } from "../EmailAddressCard";
import { useTags } from "../../../../employees/hooks/useTags";

export type Recipient = {
  value: string;
  optional?: boolean | null;
};

type RecipientListProps = {
  value: Recipient[];
  onChange: (value: Recipient[]) => void;
  placeholder?: string;
  single?: boolean;
};

export const RecipientList = ({
  value,
  onChange,
  placeholder = "Add receiver",
  single
}: RecipientListProps) => {
  const { tagTitle } = useTags();

  const toggleOptional = (index: number) => {
    onChange(value.map((r, i) => (i === index ? { ...r, optional: !r.optional } : r)));
  };

  const remove = (index: number) => {
    onChange(value.filter((_, i) => i !== index));
  };

  return (
    <Stack vertical gap="xSmall">
      {value.map((recipient, index) => (
        <EmailAddressCard
          key={`${recipient.value}-${index}`}
          value={tagTitle(recipient.value)}
          onRemove={() => remove(index)}
          actions={
            <Tooltip
              tooltip={recipient.optional ? "Optional — click to make required" : "Required — click to make optional"}
              placement="left"
            >
              <button
                onClick={() => toggleOptional(index)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: "2px",
                  display: "flex",
                  alignItems: "center"
                }}
              >
                <Asterisk
                  size={14}
                  color={recipient.optional ? "var(--palette-foreground-subdued)" : "var(--palette-primary-default)"}
                />
              </button>
            </Tooltip>
          }
        />
      ))}
      {(!single || value.length === 0) && (
        <div>
          <EmployeeFieldSelector
            fieldTypes={["email"]}
            onSelect={path => onChange([...value, { value: path }])}
            onAdd={path => onChange([...value, { value: path }])}
            startIcon="plus"
            variant="blended"
            style={value.length > 0 ? { marginTop: "var(--spacing-medium)" } : undefined}
          >
            {placeholder}
          </EmployeeFieldSelector>
        </div>
      )}
    </Stack>
  );
};
